<script>
  import Router from "svelte-spa-router";
  import Home from "./pages/Home.svelte";
  import NotFound from "./components/NotFound.svelte";
  import Login from "./pages/Login.svelte";
  import Test from "./pages/test.svelte";
  import Qr from "./pages/Qr.svelte";
  import VideoPlayer from "./pages/VideoPlayer.svelte";
  import Profile from "./pages/Profile.svelte";
  import ResetPasswordEmail from "./components/ResetPasswordEmail.svelte";
  import ResetPasswordOtp from "./components/ResetPasswordOTP.svelte";
  import TwoFa from "./pages/TwoFA.svelte";
  import Results from "./components/Results.svelte";
  import Location from "./pages/search/Location.svelte";
  import Locationdatetime from "./pages/search/Locationdatetime.svelte";
  import Datetime from "./pages/search/Datetime.svelte";
  import MyUploads from "./pages/MyUploads.svelte";
  import TopTagsSearch from "./pages/TopTagsSearch.svelte";
  import TruLensLanding from "./pages/TruLensLanding.svelte";
  import PrivacyPolicy from "./content/PrivacyPolicy.svelte";
  import SecurityPolicy from "./content/SecurityPolicy.svelte";
  import TermsAndConditions from "./content/TermsAndConditions.svelte";
  import ContactUs from "./pages/ContactUs.svelte";
  import ContactSupport from "./pages/ContactSupport.svelte";
  import Subscriptions from "./pages/Subscriptions.svelte";
  import Subscribers from "./pages/Subscribers.svelte";
  import SubscriptionPosts from "./pages/SubscriptionPosts.svelte";

  let routes = {
    "/": Home,
    "/landing": TruLensLanding,
    "/contact-us": ContactUs,
    "/customer-support": ContactSupport,
    "/tags": TopTagsSearch,
    "/uploads": MyUploads,
    "/subscriptions": Subscriptions,
    "/subscription-posts": SubscriptionPosts,
    "/subscribers": Subscribers,
    "/login": Login,
    "/test": Test,
    "/location": Location,
    "/datetime": Datetime,
    "/location-datetime": Locationdatetime,
    "/results": Results,
    "/qr": Qr,
    "/2fa": TwoFa,
    "/profile": Profile,
    "/video/:videoId": VideoPlayer,
    "/reset-password": ResetPasswordEmail,
    "/reset-password/otp": ResetPasswordOtp,
    "/privacy-policy": PrivacyPolicy,
    "/security-policy": SecurityPolicy,
    "/terms-and-conditions": TermsAndConditions,

    "*": NotFound,
  };
</script>

<main>
  <Router {routes} />
</main>

<style>
</style>
